import * as UIUtil from '/app/js/util/UI.js';
import * as Menu from "/app/js/common/Menu.js";

export const init = async function () {

    const htmlUrl = `Header.html`;
    // .headerWrap의 다음에 htmlUrl를 fetch하여 삽입한다.
    const target = document.querySelector("#wrap");
    await UIUtil.load(target, htmlUrl, false).then(() => {
        initEvt();
        updateGnbActiveState();
    });
}

export const updateGnbActiveState = function() {
    // 현재 활성화된 메뉴의 부모 메뉴를 찾아서 GNB에 'on' 클래스 추가
    const activeMenuKey = Menu.getActiveMenuKey();
    if (!activeMenuKey) return;

    const parentKey = Menu.getParentKey(activeMenuKey);
    if (!parentKey) return;

    // GNB 메뉴 매핑 (부모 키 -> GNB 인덱스)
    const gnbMap = {
        'aboutus': 0,
        'esg': 1,
        'business': 2,
        'product': 3,
        'client': 4,
        'prcenter': 5
    };

    // 모든 GNB li에서 'on' 클래스 제거
    document.querySelectorAll('.gnbWrap > li').forEach(li => {
        li.classList.remove('on');
    });

    // 현재 활성화된 메뉴의 부모에 해당하는 GNB li에 'on' 클래스 추가
    const gnbIndex = gnbMap[parentKey];
    if (gnbIndex !== undefined) {
        const gnbItems = document.querySelectorAll('.gnbWrap > li');
        if (gnbItems[gnbIndex]) {
            gnbItems[gnbIndex].classList.add('on');
        }
    }
}

function initEvt() {
    document.querySelector('.logo > a').addEventListener('click', function (e) {
        Menu.openMenu('Main');
    });

    initMenu();
    initLangTool();
    initFullScreenMenu();
}

function initMenu() {

    //그룹메뉴
    document.querySelectorAll('.gnbWrap > li > a').forEach(function (el) {
        //클릭 시, 해당 text를 소문자로 변환 및 띄어쓰기 제거
        el.addEventListener('click', function (e) {
            const parentKey = this.innerText.toLowerCase().replace(/\s+/g, '');
            const menuKey = Menu.getKeyMenuByParent(parentKey);
            if(menuKey === Menu.getActiveMenuKey()) {
                return;
            }
            Menu.openMenu(menuKey);
        });
    });

    //서브메뉴
    document.querySelectorAll('.innerWrap a[key]').forEach(function (el) {
        el.addEventListener('click', function (e) {
            const menuKey = this.getAttribute('key');
            if(menuKey === Menu.getActiveMenuKey()) {
                return;
            }
            Menu.openMenu(menuKey);
        });
    });
    document.querySelectorAll('.fullscreen-menu a[key]').forEach(function (el) {
        el.addEventListener('click', function (e) {
            const menuKey = this.getAttribute('key');
            if(menuKey === Menu.getActiveMenuKey()) {
                return;
            }
            Menu.openMenu(menuKey);
        });
    });


}

function initLangTool() {

    // 언어 지원 - 퍼블리싱 활용
    $('.lang-wrap button').on('click', function(e) {
        $(this).siblings('.langbox').toggleClass('open');
    });
    $('.langbox a').on('click', function(e) {
        $(".langbox a").removeClass("active");
        $(this).addClass("active");
        var selectedLang = $(this).data('lang');
        var selectedText = $(this).text();
        // console.log(selectedLang);

        $('.btn-lang').text(selectedText);

        $(this).closest('.langbox').removeClass('open');

        const currentLang = document.documentElement.lang;
        const changeLangKey = selectedLang === 'KOR' ? 'ko' : 'en';
        if(currentLang !== changeLangKey) {
            UIUtil.changeLang(selectedLang, true);
        }

    });
    $('.fullscreen-menu .menu-lang a').on('click', function(e) {
        const selectedLang = $(this).text();

        const currentLang = document.documentElement.lang;
        const changeLangKey = selectedLang === 'KOR' ? 'ko' : 'en';
        if(currentLang !== changeLangKey) {
            UIUtil.changeLang(selectedLang, true);
        }
    });

    const selectedLang = document.documentElement.lang === 'ko' ? 'KOR' : 'ENG';
    $('.btn-lang').text(selectedLang);
    $('.langbox a.active').removeClass('active');
    $('.langbox a[data-lang="' + selectedLang + '"]').addClass('active');

}

function initFullScreenMenu() {
    //풀스크린창 메뉴 - 퍼블리싱 활용
    $(function(){
        $('.mainMenu').on('click', function(){
            $('.fullscreen-menu').fadeIn(100);
            $('.fullscreen-menu').on('scroll touchmove mousewheel', function(e){
                e.preventDefault();
                e.stopPropagation();
                return false;
            })
        });
        $('.btn-close').on('click', function(){
            $('.fullscreen-menu').fadeOut(100);
        });
    });

}